<template>
  <div>
            <v-card class="ml-auto mr-auto" max-width="400px">
              <v-toolbar color="black" dark>
                <v-toolbar-title class="mw-h2">Login</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text class="text-right">
                <v-form>
                  <v-text-field
                    label="Login"
                    name="login"
                    v-model="login" 
                    prepend-icon="fa-user"
                    type="text"
                  />
                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    v-model="password" 
                    prepend-icon="fa-lock"
                    type="password"
                  />
                </v-form>
              </v-card-text>
              <div >
                <v-alert :value="error" dense text type="warning">{{errorMsg}}</v-alert>
              </div>  
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text v-on:click="submit">Login</v-btn>
              </v-card-actions>
            </v-card>

    </div>
</template>
<script>
import Vuex from 'vuex' 
export default {
  data() {
    return {
      error: null,
      errorMsg: "",
      login: "",
      password: "",
    };
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.auth.user,
      view: state => state.auth.view,
    }),
  },
  methods: {
    submit() {
      var self = this;
      const email = self.login;
      const password = self.password;
      self.$store.dispatch('login', { email, password })
      .then( () => {
        self.$store.dispatch('loggedIn')
        self.$emit("loggedIn");
      })
      .catch(() => {
        this.error = true;
        this.errorMsg = "That didn't work. Please try again or contact Meisterworks"
      })
    }
  },
  watch:{ 
    view: {
      immediate: false, 
      handler: function(view){
        this.$emit("loggedIn", view);
      }
    }
  }
};
</script>